import { DataAccessService } from '../../core/api';

export async function addRepo(url, managerAlias, repoType, reason) {
  const client = new DataAccessService({
    baseURL: `${window.location.protocol}//${window.location.host}`,
  });

  await client.post(`/repos`, { url, managerAlias, repoType, reason }, {});
}
